import { render } from "./JobDescriptionInput.vue?vue&type=template&id=8730ddba"
import script from "./JobDescriptionInput.vue?vue&type=script&lang=js"
export * from "./JobDescriptionInput.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__